(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-media-product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '')
      .toLowerCase()
      .normalize('NFKC')
      .replace(/[\s_\-/]+/g, '')
      .replace(/[^a-z0-9\u3400-\u9fff]/g, '');

    const readVariants = (root) => {
      try {
        return JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const formatMoney = (root, cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: root.dataset.currency
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    };

    const findVariant = (root, input) => {
      const variants = readVariants(root);
      const position = Number(root.dataset.colorPosition) - 1;
      const selected = normalize(input.value);
      const matches = variants.filter((variant) => normalize(variant.options[position]) === selected);
      return matches.find((variant) => variant.available) || matches[0];
    };

    const updateMedia = (root, input, variant) => {
      const linkKey = root.dataset.linkKey || 'product-media';
      const color = input.dataset.color || input.value;
      window.GluProductColorState = window.GluProductColorState || {};
      const featuredImage = variant?.featured_image?.src || '';
      window.GluProductColorState[linkKey] = { color, variantId: variant?.id || null, featuredImage };
      window.dispatchEvent(new CustomEvent('glu:product-color-change', {
        detail: { linkKey, color, variantId: variant?.id || null, featuredImage }
      }));
    };

    const updateProduct = (root, input) => {
      const variant = findVariant(root, input);
      updateMedia(root, input, variant);
      root.querySelectorAll('[data-color-name]').forEach((element) => {
        element.textContent = input.value;
      });
      if (!variant) return;

      root.querySelectorAll('[data-variant-id]').forEach((element) => {
        element.value = variant.id;
        element.dispatchEvent(new Event('change', { bubbles: true }));
      });
      root.querySelectorAll('[data-price]').forEach((element) => {
        const compare = element.dataset.showCompare === 'true' && variant.compare_at_price > variant.price
          ? `<s>${formatMoney(root, variant.compare_at_price)}</s>`
          : '';
        element.innerHTML = `${compare}<span>${formatMoney(root, variant.price)}</span>`;
      });
      root.querySelectorAll('[data-add]').forEach((button) => {
        button.disabled = !variant.available;
        const label = button.querySelector('[data-add-text]');
        if (label) label.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldLabel;
      });
    };

    const initialize = (scope = document) => {
      const roots = [];
      if (scope.matches?.('.pdb')) roots.push(scope);
      scope.querySelectorAll?.('.pdb').forEach((root) => roots.push(root));
      roots.forEach((root) => {
        const checked = root.querySelector('.pdb__radio:checked');
        if (checked) updateProduct(root, checked);
        root.style.removeProperty('transform');
      });
    };

    if (!window.productDetailBlocksEventsInstalled) {
      window.productDetailBlocksEventsInstalled = true;
      document.addEventListener('change', (event) => {
        const input = event.target.closest?.('.pdb__radio');
        if (!input || !input.checked) return;
        const root = input.closest('.pdb');
        if (root) updateProduct(root, input);
      });
      document.addEventListener('click', (event) => {
        const swatch = event.target.closest?.('.pdb__swatch');
        if (!swatch) return;
        const input = document.getElementById(swatch.dataset.colorInput);
        const root = swatch.closest('.pdb');
        if (!input || !root) return;
        event.preventDefault();
        input.checked = true;
        updateProduct(root, input);
        if (swatch.href) window.history.replaceState({}, '', swatch.href);
      });
      window.addEventListener('glu:product-media-ready', (event) => {
        const linkKey = event.detail?.linkKey;
        document.querySelectorAll('.pdb[data-link-key]').forEach((root) => {
          if (root.dataset.linkKey !== linkKey) return;
          const checked = root.querySelector('.pdb__radio:checked');
          if (checked) updateProduct(root, checked);
        });
      });
      document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
